import { render, staticRenderFns } from "./pg-table.vue?vue&type=template&id=4c99f67c&scoped=true"
import script from "./pg-table.vue?vue&type=script&lang=js"
export * from "./pg-table.vue?vue&type=script&lang=js"
import style0 from "./pg-table.vue?vue&type=style&index=0&id=4c99f67c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99f67c",
  null
  
)

export default component.exports